import {
  Flex, HStack, Icon, IconButton, Select, Text, Tooltip,
} from '@chakra-ui/react';
import { FaSyncAlt } from 'react-icons/fa';
import InputSetting from '../InputSetting';
import ColorPicker from '../ColorPicker/ColorPicker';

const fontWeigthOptions = [
  { key: 'normal', value: 'Normal' },
  { key: 'bold', value: 'Bold' },
  { key: 'lighter', value: 'Lighter' },
];

const fontStyleOptions = [
  { key: 'normal', value: 'Normal' },
  { key: 'italic', value: 'Italic' },
];
const TextStyles = ({
  fontSize, fontWeight, fontStyle, color, onChange,
}) => (
  <>
    <Flex justify="space-between" w="100%">
      <InputSetting
        label="Font size"
        value={fontSize}
        onChange={(v) => onChange({ size: v })}
        regex={/^([0-9]+ ?px)?$/}
        errorMessage="Size must be in px"
      />
    </Flex>
    <Flex justify="space-between" w="100%" alignItems="center">
      <Text>Font weight</Text>
      <Select
        value={fontWeight}
        onChange={(e) => onChange({ fontWeight: e.target.value })}
        w="unset"
      >
        {fontWeigthOptions.map(({ key, value }) => <option key={key} value={key}>{value}</option>)}
      </Select>
    </Flex>
    <Flex justify="space-between" w="100%" alignItems="center">
      <Text>Font style</Text>
      <Select
        value={fontStyle}
        onChange={(e) => onChange({ fontStyle: e.target.value })}
        w="unset"
      >
        {fontStyleOptions.map(({ key, value }) => <option key={key} value={key}>{value}</option>)}
      </Select>
    </Flex>
    <Flex justify="space-between" w="100%" alignItems="center">
      <Text>Color</Text>
      <HStack>
        <ColorPicker
          color={color}
          onChange={(c) => onChange({ color: c })}
        />
        <Tooltip label="Same as text">
          <IconButton icon={<Icon as={FaSyncAlt} />} size="xs" onClick={() => onChange({ color: '' })} />
        </Tooltip>
      </HStack>
    </Flex>
  </>
);

export default TextStyles;
